/**
 * Compliance API Client
 *
 * Phase 3.5-C: Operational Intelligence
 */

import type { LawsComplianceState, AuditTriggerResponse } from '../types/compliance';

const API_BASE = '/api/admin/dashboard';

type AuthFetch = (url: string, options?: RequestInit) => Promise<Response>;

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || `Request failed (${response.status})`);
  }
  return response.json();
}

export const fetchComplianceState = async (
  authFetch: AuthFetch,
): Promise<LawsComplianceState> => {
  const response = await authFetch(`${API_BASE}/compliance/laws`);
  return handleResponse<LawsComplianceState>(response);
};

export const triggerComplianceAudit = async (
  authFetch: AuthFetch,
): Promise<AuditTriggerResponse> => {
  const response = await authFetch(`${API_BASE}/compliance/audit`, { method: 'POST' });
  return handleResponse<AuditTriggerResponse>(response);
};
